import { LoadingButton } from '@mui/lab';
import { AppBar, Toolbar, Typography, Button, Stack, TextField, Divider, LinearProgress, CircularProgress, MenuItem } from '@mui/material'
import { addDoc, arrayUnion, collection, deleteDoc, doc, updateDoc } from 'firebase/firestore';
import { getDownloadURL, getStorage, ref, uploadBytesResumable } from 'firebase/storage';
import React, { useState } from 'react'
import Dropzone from 'react-dropzone';
import { auth, db } from '../../../firebase';
import buildingCategories from '../../../_mock/buildingCategories';
// eslint-disable-next-line react/prop-types
function EditItem({handleClose, data}) {

    const storage = getStorage()    
     const [loading, setloading] = useState(false)
     const [category, setcategory] = useState(data.category)
    const [name, setname] = useState(data.name)
    const [price, setprice] = useState(data.price)
    const [condition, setcondition] = useState(data.condition)
    const [type, settype] = useState(data.type)
    const [description, setdescription] = useState(data.description)
    const [location, setlocation] = useState(data.location)

    const handleMultipleImageChange =async () => {
       await updateDoc(doc(db, 'marketplace', data.id), {
            name,
            price,
            condition,
            type,
            description,
            location,
            category,
            updateAt: Date.now(), 
          }).then(()=>{
            console.log("Item updated")
            handleClose()
          });
    }; 
    
    const provinces = [
      "Central",
      "Copperbelt",
      "Eastern",
      "Luapula",
      "Lusaka",
      "Muchinga",
      "Northern",
      "North-Western",
      "Southern",
      "Western"
    ];

    async function  deleteListing(){
            await deleteDoc(doc(db, "marketplace", data.id)).then(()=>{
                handleClose()
            })
    }
  
 
  return (
    auth.currentUser?.uid && <div>
           <AppBar sx={{ position: 'relative' }}>
          <Toolbar>
          
            <Typography>Edit Listing </Typography>
          </Toolbar>
        </AppBar>
        <Stack spacing={3} alignItems={"center"} p={3} >
        <TextField
        fullWidth select
        label="Type"
        value={type}
        onChange={(event) => settype(event.target.value)}
      >
      <MenuItem value="SELL">Sell</MenuItem>
      <MenuItem value="RENT">Rent</MenuItem>
      <MenuItem value="HIRE">Hire</MenuItem>
      </TextField>

            <TextField fullWidth select label="Category" value={category} onChange={(event) => setcategory(event.target.value)}>
      {buildingCategories.map((bc, index)=>(
        <MenuItem value={bc.name} key={index}>{bc.name}</MenuItem>
      ))}
      </TextField>

      <TextField
        fullWidth 
        label="Title"
        value={name}
        onChange={(event) => setname(event.target.value)}
      />
         <TextField
        fullWidth rows={5} multiline
         type="post"
        label="Description"
        value={description}
        onChange={(event) => setdescription(event.target.value)}
      />
      <TextField
        fullWidth 
         type="number"
        label="Price"
        value={price}
        onChange={(event) => setprice(event.target.value)}
      />
       <TextField
        fullWidth select
        label="Condition"
        value={condition}
        onChange={(event) => setcondition(event.target.value)}
      >
      <MenuItem value="NEW">New</MenuItem>
      <MenuItem value="GOOD">Used - Good</MenuItem>
      <MenuItem value="LIKE_NEW">Used - Like New</MenuItem>
      <MenuItem value="FAIR">Used - Fair</MenuItem>
      </TextField> 
      <TextField fullWidth select label="Location" value={location} onChange={(event) => setlocation(event.target.value)}>
      {provinces.map((p, index)=>(
        <MenuItem value={p} key={index}>{p}</MenuItem>
      ))}
      </TextField>
 
      <LoadingButton loading={loading} fullWidth variant="contained" onClick={()=>handleMultipleImageChange()} color="success">Update</LoadingButton>
     
      <Typography sx={{ ml: 2, flex: 1 }} variant="overline" component="div">
           Listings on the marketplace are public and can be seen by people on and off the platform. Listings may also be used for promotion of the platform.
            </Typography>

        </Stack>
        <Divider sx={{my:3}}>Danger Zone</Divider>

        <Stack sx={{p:3}}>
            <Button variant='outlined' color="error" onClick={()=>deleteListing()} >Delete Listing</Button>
        </Stack>
    </div>
  )
}
export default EditItem